import { render, staticRenderFns } from "./ServiceQuestionTypeForm.vue?vue&type=template&id=ce15b57a"
import script from "./ServiceQuestionTypeForm.vue?vue&type=script&lang=js"
export * from "./ServiceQuestionTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports